import React, { FC, useEffect, useState } from 'react';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { ReactComponent as RecordIcon } from 'assets/icons/record.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { RiderAltIcon, RidersIcon } from 'cokitchen-icons';
import useRoleContext from 'contexts/role.context';
import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';
type PartnersCardOptionsTypes = {
  editPartnerDetails: () => void;
  deletePartner: () => void;
  recordPayment: () => void;
  addRiders: () => void;
  addManagers: () => void;
};
const PartnersCardOptions: FC<PartnersCardOptionsTypes> = ({
  editPartnerDetails,
  deletePartner,
  recordPayment,
  addManagers,
  addRiders
}) => {
  const { role } = useRoleContext();
  const BASE_OPTIONS = [
    {
      name: 'Edit partner details',
      icon: <EditIcon />,
      onClick: editPartnerDetails
    },
    {
      name: 'Add manager',
      icon: <RidersIcon />,
      onClick: addManagers
    },
    {
      name: 'Add riders',
      icon: <RiderAltIcon />,
      onClick: addRiders
    }
  ];
  const [options, setOptions] = useState(BASE_OPTIONS);

  useEffect(() => {
    const allTabs =
      role === ENUM_ROLE.LOGISTICS_ADMIN
        ? BASE_OPTIONS
        : [
            {
              name: 'Record payment',
              icon: <RecordIcon />,
              onClick: recordPayment
            },
            ...BASE_OPTIONS,
            {
              name: 'Delete partner',
              icon: <DeleteIcon />,
              onClick: deletePartner
            }
          ];
    setOptions(allTabs);
  }, []);

  return (
    <Dropdown content={<span className='underline text-red-5 cursor-pointer'>Quick options</span>}>
      <DropdownList>
        {options.map((option) => (
          <DropdownItem
            key={option.name}
            className={`${option.name === 'Delete partner' && 'text-red-5'}`}
            onClick={() => option.onClick()}>
            {option.icon}
            <span className='ml-2'>{option.name}</span>
          </DropdownItem>
        ))}
      </DropdownList>
    </Dropdown>
  );
};

export default PartnersCardOptions;
